import { render } from "./dash-v3.vue?vue&type=template&id=e039963a&scoped=true"
import script from "./dash-v3.vue?vue&type=script&lang=js"
export * from "./dash-v3.vue?vue&type=script&lang=js"

import "./dash-v3.vue?vue&type=style&index=0&id=e039963a&lang=scss"
import "./dash-v3.vue?vue&type=style&index=1&id=e039963a&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e039963a"]])

export default __exports__